module.exports = __webpack_public_path__ + "static/img/banner_solutions_customization.2c66a0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/solution/banner_solutions_customization.png
// module id = nf6q
// module chunks = 10